import { createContext, useContext, useMemo } from 'react';
import { AppContext } from './AppProvider';
import { useFunctions } from './useHelpers/useFunctions';

const _showCallLogs = true

export const FunctionsContext = createContext();

/**
 * 
 * @param {*} param0 
 * @returns functions_state and functions_fns (fc_notifications, fc_sheets, etc.)
 */
const FunctionsProvider = ({ children }) => {

  const appContext = useContext(AppContext);
  const { app_state } = appContext
  const { mainFunctions, app_alts, app_prods, mainStorage } = app_state
  const { altFunctions } = app_alts ?? {}
  const { prodFunctions } = app_prods ?? {}

  const { fn_cls } = useFunctions()

  const allFunctions = {
    mainFunctions,
    altFunctions,
    prodFunctions
  }


  const functions_cls = useMemo(() => {
    return fn_cls
  }, [fn_cls]);

  return (
    <FunctionsContext.Provider
      value={{
        functions_cls,
      }}
    >
      {children}
    </FunctionsContext.Provider>
  );
};

export default FunctionsProvider;
